import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { ThunkDispatch } from 'redux-thunk'

import type { CmsPageFields } from '../page/types'
import { fetchCmsBlocks } from './fetchCmsBlocks'
import type { CmsFetcher } from './fetchCmsBlocks'
import { cmsBlockKey } from './types'
import type { CmsBlockAction, CmsBlockDescriptor, CmsBlockState, CmsBlocksState } from './types'

type StateWithCmsBlocks = { cmsBlocks: CmsBlocksState }

const EMPTY_STATE: CmsBlockState = { data: null, loading: false, error: false }

export function useCmsBlock(
  descriptor: CmsBlockDescriptor,
  fetcher: CmsFetcher,
): { data: CmsPageFields | null; loading: boolean; error: boolean } {
  const key = cmsBlockKey(descriptor)
  const slice = useSelector<StateWithCmsBlocks, CmsBlockState>(
    (state) => state.cmsBlocks?.[key] ?? EMPTY_STATE,
  )
  const dispatch = useDispatch<ThunkDispatch<StateWithCmsBlocks, void, CmsBlockAction>>()
  const shouldFetch = slice.data === null && !slice.loading && !slice.error

  useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchCmsBlocks([descriptor], fetcher))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, shouldFetch])

  return slice
}
